import { Bucket } from './bucket.js';
import { wrapHash } from './consumable-hash.js';
export function createHAMT(options) {
    if (options == null || options.hashFn == null) {
        throw new Error('please define an options.hashFn');
    }
    const bucketOptions = {
        bits: options.bits ?? 8,
        hash: wrapHash(options.hashFn)
    };
    return new Bucket(bucketOptions);
}
export { Bucket };
